import { ENTITY_TYPES } from '@adsk/bim360-matrix-react-entity-linker';

export default asset => ({ ...asset, entityType: ENTITY_TYPES.ASSET });
